import RiskLineChart from './RiskLineChart'

export default RiskLineChart
